import type { ReferenceWithCount } from '../types';

interface CityFilterProps {
  selectedId: string | null;
  onChange: (id: string | null) => void;
  cities?: ReferenceWithCount[];
  loading?: boolean;
}

export function CityFilter({ selectedId, onChange, cities = [], loading = false }: CityFilterProps) {
  return (
    <select
      aria-label="Filtrar por ciudad"
      className="input py-2 text-sm"
      value={selectedId ?? ''}
      onChange={(e) => onChange(e.target.value || null)}
      disabled={loading}
    >
      <option value="">Todas las ciudades</option>
      {cities.map((city) => (
        <option key={city.id} value={city.id}>
          {city.name}
          {city.recommendationCount > 0 ? ` (${city.recommendationCount})` : ''}
        </option>
      ))}
    </select>
  );
}